// extracted by mini-css-extract-plugin
module.exports = {"inner":"ViewPartners_inner__2kgLu","partners_list":"ViewPartners_partners_list__Y9JmC"};